export enum JobMessengerPlacement {
    Inbox = 'inbox',
    Stories = 'stories',
}

export const getJobMessengerPlacementDisplayName = (messengerPlacement: JobMessengerPlacement): string => {
    switch (messengerPlacement) {
        case JobMessengerPlacement.Inbox:
            return 'Inbox';
        case JobMessengerPlacement.Stories:
            return 'Stories';
    }
};
